// Shared tokens for the equipment module (non-printer machines: laminators,
// workstations, label printers, light booths, etc).
export const TAN = '#B5A87A';

export const STATUS_LABEL = {
  active: 'Active', semi_active: 'Semi-active', inactive: 'Inactive', decommissioned: 'Decommissioned',
};

export const STATUS_PILL = {
  active:         'bg-status-ok/[0.12] border-status-ok/[0.3] text-status-ok',
  semi_active:    'bg-ink-yellow/[0.12] border-ink-yellow/[0.3] text-ink-yellow',
  inactive:       'border-border-strong text-text-tertiary',
  decommissioned: 'border-border-strong text-text-tertiary',
};

export const trimOrNull = (v) => { const s = (v ?? '').trim(); return s === '' ? null : s; };
